import i18n from "@/i18n";

var width: number;
var height: number;
var images: HTMLCollection;
const dragImage = function (editor: any) {
    editor.ui.registry.addToggleButton("dragImage", {
        icon: "vsc-draggable",
        tooltip: i18n.t("htmlEditor.dragImage"),
        onAction: function (api: any) {
            var node: HTMLElement = editor.selection.getNode();
            if (node.tagName !== "IMG") return;

            if (!node.classList.contains("imageDrag")) {
                node.classList.add("imageDrag");
                node.style.top = node.offsetTop + "px";
                node.style.left = node.offsetLeft + "px";
                node.style.position = "absolute"; // Wait with applying absolute until the offset has been defined above
                Draggable(node);
                api.setActive(true);
            } else {
                node.classList.remove("imageDrag");
                node.style.position = "";
                node.style.left = "";
                node.style.top = "";
                node.setAttribute("data-mce-style", node.style.cssText);
                var newElem: any = node.cloneNode();
                node.parentElement!.replaceChild(newElem, node);
                newElem.click();
                api.setActive(false);
            }
        },
        onSetup: function (api: any) {
            if (!editor.getBody().classList.contains("dragReady")) {
                editor.getBody().classList.add("dragReady");
                // Make sure elements previously set to draggable are draggable on load
                editor.on("SetContent", function () {
                    images = editor.getBody().getElementsByClassName("imageDrag");
                    for (const item of images) {
                        Draggable(item);
                    }
                });
                editor.on("selectionChange", function () {
                    var node: HTMLElement = editor.selection.getNode();
                    node.classList.contains("imageDrag") ? api.setActive(true) : api.setActive(false);
                });
            }
        }
    });

    function Draggable(el: any) {
        width = editor.getBody().clientWidth;
        height = editor.getBody().scrollHeight;

        var maxI: string;
        var x = 0;
        var y = 0;
        function mUp() {
            el.isDown = false;
            editor.getBody().removeEventListener("mousemove", mMove);
            editor.getBody().removeEventListener("mouseleave", mLeave);
            // Image z-index stack
            el.style.zIndex = "";
            var zs = [];
            for (const item of images) {
                zs.push((item as any).style.zIndex);
            }
            maxI = (1 + Math.max(...zs)) + "";
            el.style.zIndex = maxI;
            el.setAttribute("data-mce-style", el.style.cssText);
        }
        function mLeave() {
            if (el.isDown) mUp();
        }
        function mDown(e: any) {
            el.isDown = true;
            e.preventDefault(); // is called during the mousedown event to prevent the default drag action.
            editor.getBody().addEventListener("mousemove", mMove);
            editor.getBody().addEventListener("mouseleave", mLeave);
            el.offset = [
                el.offsetLeft - e.clientX,
                el.offsetTop - e.clientY
            ];
            x = (e.clientX + el.offset[0]);
            y = (e.clientY + el.offset[1]);
            el.style.zIndex = "1000001";
        }
        function mMove(e: any) {
            if (!el.isDown) return;
            e.preventDefault();
            if (e.clientX + el.offset[0] >= 0 && e.clientX + el.offset[0] + el.clientWidth <= width) {
                x = (e.clientX + el.offset[0]);
                el.style.left = x + "px";
            }
            if (e.clientY + el.offset[1] >= 0 && e.clientY + el.offset[1] + el.height <= height) {
                y = (e.clientY + el.offset[1]);
                el.style.top = y + "px";
            }
        }
        // Clone and replace to remove existing event listeners
        var clone = el.cloneNode();
        el.parentNode.replaceChild(clone, el);
        el = clone;
        // Add event listeners
        el.addEventListener("mousedown", mDown);
        el.addEventListener("mouseup", mUp);
    };
};

export { dragImage };
